// extracted by mini-css-extract-plugin
module.exports = {"rounded":"NextImage_rounded__CxUDc","shadows":"NextImage_shadows__zS_qV"};